import { NgModule } from "@angular/core";
import { DashboardComponent } from "@uppy/angular";
import { CommonModule } from "common";
import { DocumentRoutingModule } from "./document-routing.module";
import { SharedModule } from "../shared/shared.module";
import { AccountDocumentListComponent } from "./document-list/account-document-list.component";
import { ApplicationDocumentListComponent } from "./document-list/application-document-list.component";
import { DocumentRenditionsPipe } from "./document-list/document-renditions.pipe";
import { DocumentListFilterDialogComponent } from "./document-list-filter-dialog/document-list-filter-dialog.component";
import { ApplicationDocumentUploadComponent } from "./document-upload/application-document-upload.component";
import { RequestStatementDialogModule } from "./request-statement-dialog/request-statement-dialog.module";

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    DocumentRoutingModule,
    DashboardComponent,
    RequestStatementDialogModule,
  ],
  declarations: [
    AccountDocumentListComponent,
    ApplicationDocumentListComponent,
    DocumentListFilterDialogComponent,
    ApplicationDocumentUploadComponent,
    DocumentRenditionsPipe,
  ],
})
export class DocumentModule {}
